'use client';
import { objectValues } from '@s7/utils';

/**
 * Определяет, вставлен ли скрипт аналитики на страницу.
 * Используется для предотвращения повторной инициализации.
 * */ const isScriptInjected = (scriptSource)=>{
    const scripts = document.querySelectorAll('script[src]');
    const regex = new RegExp(`^${scriptSource}`);
    return Boolean(objectValues(scripts).filter((value)=>regex.test(value.src)).length);
};

export { isScriptInjected };
//# sourceMappingURL=isScriptInjected.js.map
